// extracted by mini-css-extract-plugin
export default {"topcontent":"PolicyContent_topcontent__6RZiZ","container":"PolicyContent_container__I0x8s","list":"PolicyContent_list__dQngb"};